import React from 'react';

import { topicsLink, homeLink, subCategories } from '../../utils/consts';
import * as S from './styles';
import SubHeaderNavLink from './SubHeaderNavLink';

export function SubHeader() {
  return (
    <S.SubHeaderWrapper data-testid="subHeader">
      <S.SubHeaderContent>
        <S.MobileContentWrapper>
          <SubHeaderNavLink key={homeLink.label} link={homeLink} secondary />
          <SubHeaderNavLink key={topicsLink.label} link={topicsLink} />
        </S.MobileContentWrapper>
        <S.DesktopContentWrapper>
          <S.Left>
            <SubHeaderNavLink key={homeLink.label} link={homeLink} secondary />
          </S.Left>
          <S.Right>
            <>
              <li>
                <S.TopicsLink to="/categories">Topics:</S.TopicsLink>
              </li>
              {subCategories.map((link) => (
                <SubHeaderNavLink
                  data-testId="category-link"
                  key={link.node.id}
                  link={{
                    label: link.node.title,
                    url: `/categories/${link.node.slug}`,
                  }}
                />
              ))}
              <SubHeaderNavLink
                link={{ label: 'More...', url: '/categories' }}
              />
            </>
          </S.Right>
        </S.DesktopContentWrapper>
      </S.SubHeaderContent>
    </S.SubHeaderWrapper>
  );
}

export default SubHeader;
